import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@/contexts/auth-context';
import { getBoardLandingRoute, usePermissions } from '@/hooks/use-permissions';
import type { UserRole } from '@/lib/types';

interface RoleRouteProps {
  /** Org roles allowed to open the page. */
  roles: readonly UserRole[];
  children: ReactNode;
}

/**
 * Role gate for pages inside the authenticated layout. Anyone outside
 * `roles` is sent to their own home surface (My Dashboard for crew,
 * the H3ightboard for everyone else) instead of seeing the page.
 * ProtectedRoute has already handled loading and sign-in.
 */
export function RoleRoute({ roles, children }: RoleRouteProps) {
  const { user } = useAuth();
  const { boardPersona } = usePermissions();

  if (!user?.role || !roles.includes(user.role)) {
    return <Navigate to={getBoardLandingRoute(boardPersona)} replace />;
  }

  return <>{children}</>;
}
